<template>
  <div></div>
</template>

<script>
export default {
  name: 'ShopifyRedirect',
  mounted() {
    // Seta o cookie da shopify
    try {
      this.$cookie.set("utm_source", 'shopify', 7);
    } catch (e) {
      // noop
    }

    // Ir para a tela de cadastro sem query params
    this.$router.replace({ name: 'UserRegister' });
  }
};
</script>
